import * as itemType from "./alertTimelineItemTypes";

export default alert => {
  const items = [];

  const setItemDescription = event => {
    if (event.alertStatus != null) {
      return "changed the status to";
    }
    if (event.alertWorkOrder != null) {
      return "Added work order";
    } else {
      if (event.includeDataInBaseline != null) {
        if (event.includeDataInBaseline === true) {
          return "Included data for this alert in baseline calculations";
        } else {
          return "Excluded data for this alert in baseline calculations";
        }
      }
    }
  };

  const workflowEvents = alert.alertWorkflowEvents;
  if (workflowEvents) {
    workflowEvents.forEach(event => {
      items.push({
        date: event.timestamp,
        user: {
          name: event.user.name
        },
        action: setItemDescription(event),
        alertStatus: {
          description:
            event.alertStatus == null ? "" : event.alertStatus.description
        },
        type: itemType.WORKFLOW_EVENT
      });
    });
  }

  const comments = alert.alertComments;
  if (comments) {
    comments.forEach(comment => {
      items.push({
        date: comment.created,
        user: {
          name: comment.user.name
        },
        description: comment.content,
        alertStatus: {},
        type: itemType.COMMENT
      });
    });
  }

  const alertWorkOrders = alert.alertWorkOrders;
  if (alertWorkOrders) {
    alertWorkOrders.forEach(alertWorkOrders => {
      items.push({
        date: alertWorkOrders.created,
        user: {
          name: alertWorkOrders.user.name
        },
        workOrderNumber: alertWorkOrders.workOrderNumber,
        type: itemType.WORK_ORDER_EVENT
      });
    });
  }

  items.sort((a, b) => {
    return new Date(b.date) - new Date(a.date);
  });

  return {
    items: items,
    alert: {
      opened: alert.opened
    }
  };
};
